export enum Actions {
    SetFormState,
    SetStatus,
    SetIsBusy,
    SetSubmitRequested,
    UpdateComposition,

    UpdateStripeState,
    UpdateCreditCard,
    UpdateIsBusy,
    SetIdempotencyKey,
    EditCreditCard,

    SetUpdateFieldCallback,
}
